module.exports = __webpack_public_path__ + "img/TCC-Logo.0b1c7262.png";